import { z } from "zod";

export const SettingSchema = z.object({
    settingName: z.string(),
    settingValue: z.string().nullable(),
});

export const SettingListSchema = z.array(SettingSchema);

export type Setting = z.infer<typeof SettingSchema>;